import axios from 'axios'

export const AuthApi = {
    async Login(data){
        const response = await axios.post('/api/auth/login',data)
        return response
    },
}